import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNorfolkIsland = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1746)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2174 1.19072C15.6397 0.427875 13.8699 0 12 0C10.1301 0 8.36025 0.427875 6.78262 1.19072L5.73914 12L6.78262 22.8093C8.36025 23.5721 10.1301 24 12 24C13.8699 24 15.6397 23.5721 17.2174 22.8093L18.2609 12L17.2174 1.19072Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.78263 1.19113C2.76867 3.13204 0 7.24246 0 12C0 16.7575 2.76867 20.8679 6.78263 22.8088V1.19113Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2174 1.19113V22.8088C21.2314 20.8679 24 16.7575 24 12C24 7.24251 21.2314 3.13204 17.2174 1.19113Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1304 15.6522L12 5.73914L8.86951 15.6522H11.2173V18.2609H12.7826V15.6522H15.1304Z",
				fill: "#6DA544"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1746",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgNorfolkIsland;
